import { combineReducers } from "redux";
import forms from "./forms";

export default combineReducers({ forms });
